import { apiRequest, invalidateCache } from './api.js';

export function createFeaturesService(helium) {
	const featuresChannel = helium.factory('features:flags', {});
	
	const getFeatures = async (signal) => {
		const features = await apiRequest('/api/v1/admin/features', { signal }, true);
		featuresChannel.send(() => features);
		return features;
	};
	
	const updateFeatures = async (planSlug, features, signal) => {
		invalidateCache('/api/v1/admin/features');
		const plan = await apiRequest('/api/v1/admin/features', {
			method: 'PATCH',
			body: JSON.stringify({ planSlug, features }),
			signal
		});
		
		featuresChannel.send(current => ({
			...current,
			[planSlug]: {
				name: plan.displayName,
				features: plan.features
			}
		}));
		
		return plan;
	};
	
	return { featuresChannel, getFeatures, updateFeatures };
}
